const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const get = require('lodash/object/get');
const { APIGet } = require('utilities/APIRequestHelper');
const { requestAccounts } = require('actions/getAccounts');

const requestInterveners = accountId => ({
    type: actionTypes.FETCH_ACCOUNT_INTERVENERS_REQUEST,
    payload: {
        accountId
    }
});

const requestAccountIntervenersSuccess = (data = [], accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_INTERVENERS_SUCCESS,
    payload: {
        accountId,
        intervenersList: (!__CONTACT_CENTER__ ? data : get(data, 'listaConsultaTitu.datoConsultaTitu', []))
    }
});

const requestAccountIntervenersFailure = (error, accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_INTERVENERS_FAILURE,
    payload: {
        accountId,
        error
    }
});

const resetAccountInterveners = accountId => ({
    type: actionTypes.FETCH_ACCOUNT_INTERVENERS_RESET,
    payload: {
        accountId
    }
});

const requestAccountInterveners = (accountId, filterUserLoggedIn = false) => (dispatch, getState) => {
    return dispatch(requestAccounts()).then(() => {
        const immAccount = getState().accounts.get('byId').get(accountId);
        const accountsRequestData = {
            query: {
                [!__CONTACT_CENTER__ ? "product" : "producto"]: immAccount.get('product'),
                [!__CONTACT_CENTER__ ? "contractNumber" : "numeroContrato"]: immAccount.get('contractNumber'),
                filterUserLoggedIn: filterUserLoggedIn,
            }
        };

        dispatch(requestInterveners(accountId));
        const url = !__CONTACT_CENTER__ ? 'interveners' : 'intervenersCC'
        return APIGet(dispatch, apiURLBuilder.getURL(url) , accountsRequestData)
            .then(function(response) {
                dispatch(requestAccountIntervenersSuccess(response, accountId));
            },
            function(response) {
                dispatch(requestAccountIntervenersFailure(response, accountId));
            }
        );
    });
};

module.exports = {
    requestAccountInterveners,
    resetAccountInterveners
};
